import React from 'react';
import { motion } from 'framer-motion';
import RoleLoginLinks from './RoleLoginLinks';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-white overflow-x-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-5">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="lg:col-span-2 bg-white p-6 sm:p-8 md:p-10 lg:p-12 xl:p-16 max-w-6xl mx-auto flex items-center justify-center flex-col w-full"
        >
          <div className="mb-6 sm:mb-8">
            <div className="flex items-center justify-center mb-0">
              <img
                src="/images/analytical-prism-logo.svg"
                alt="Analytical Prism"
                className="h-12 sm:h-14 w-auto object-contain"
              />
            </div>
          </div>

          <div className="mb-6 sm:mb-8 text-center">
            <h2 className="text-2xl sm:text-2xl md:text-3xl lg:text-4xl font-regular font-source text-[#113861] leading-tight">
              Get in <em className="italic">touch</em>
            </h2>
          </div>

          <div className="space-y-3 sm:space-y-4 text-center mb-8">
            <p className="text-base sm:text-lg text-gray-900 underline">
              <a
                href="mailto:rohit@codersbrain.com"
                className="hover:text-blue-700 transition-colors duration-200"
              >
                rohit@codersbrain.com
              </a>
            </p>
          </div>

          <div className="w-full max-w-xs">
            <p className="text-xs font-semibold tracking-widest uppercase text-slate-400 mb-2 text-center lg:text-left">
              Portal login
            </p>
            <RoleLoginLinks linkClassName="text-[#113861] hover:text-cyan-700" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="lg:col-span-3 relative min-h-64 sm:min-h-80 md:min-h-96 lg:min-h-[500px]"
        >
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{ backgroundImage: 'url(/images/footer.png)' }}
          />
          <div className="relative z-10 h-full flex items-center justify-center" />
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.3 }}
        className="bg-white border-t border-gray-200 py-4 sm:py-5 md:py-6 text-center px-4"
      >
        <p className="text-sm sm:text-base text-gray-600 mb-2 font-sans font-regular text-[#2b2b2b]">
          &copy; {currentYear} <span className="font-semibold">Analytical Prism</span> All rights
          reserved.
        </p>
      </motion.div>
    </footer>
  );
};

export default Footer;
